/* eslint-disable prefer-destructuring */
/**
 * 获取 url 搜索部分key所对应的值
 * - 若匹配到name，则返回name的值（string类型）
 * - 若未匹配到name，则返回false（boolean类型）
 * @param name 需要获取所对应值的 key
 * @param url
 * @return 匹配键所得到的值 or false
 */
export function getRequest(name, url) {
    var urlSearch = url;
    if (!urlSearch) {
        urlSearch = window.location.href.split('?')[1];
    }
    else if (urlSearch.split('?')[1]) {
        urlSearch = urlSearch.split('?')[1];
    }
    // 去除 hash 值
    if (urlSearch) {
        urlSearch = String(urlSearch).split('#')[0];
    }
    var res = new RegExp("(^|&)".concat(name, "=([^&]*)")).exec(urlSearch);
    return !!res && res[2];
}
